//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"BendTaperAngle1",0,"Expression",0],[1,"BendTaperAngle2",0,"Expression",0],[0,"BendTaperInputMethod1",1,0],[0,"BendTaperInputMethod2",1,0],[1,"BendTaperSelectBendFace",0,"ScCollector",0],[0,"BendTaperType1",1,0],[0,"BendTaperType2",1,0],[1,"EndRadius1",0,"Expression",0],[1,"EndRadius2",0,"Expression",0],[0,"InferRadius1",1,0],[0,"InferRadius2",1,0],[1,"StartRadius1",0,"Expression",0],[1,"StartRadius2",0,"Expression",0],[0,"StartType1",1,0],[0,"StartType2",1,0],[0,"StationaryEntity",1,"NXObject",0],[1,"TaperDistance1",0,"Expression",0],[1,"TaperDistance2",0,"Expression",0],[0,"TaperSides",1,0],[1,"WebTaperAngle1",0,"Expression",0],[1,"WebTaperAngle2",0,"Expression",0],[0,"WebTaperType1",1,0],[0,"WebTaperType2",1,0]],[],[]];
SPLM.Features.SheetMetal.BendTaperBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.BendTaperBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.BendTaperBuilder.BendTaperSides = Object.freeze({
    "Both" : "Both", "Side1" : "Side1", "Side2" : "Side2", "Symmetric" : "Symmetric"});

SPLM.Features.SheetMetal.BendTaperBuilder.BendTaperType = Object.freeze({
    "Linear" : "Linear", "Tangent" : "Tangent", "Square" : "Square"});

SPLM.Features.SheetMetal.BendTaperBuilder.BendTaperInputMethod = Object.freeze({
    "Angle" : "Angle", "Distance" : "Distance", "ToEnd" : "ToEnd"});

SPLM.Features.SheetMetal.BendTaperBuilder.WebTaperType = Object.freeze({
    "None" : "None", "Face" : "Face", "FaceChain" : "FaceChain"});

SPLM.Features.SheetMetal.BendTaperBuilder.StartType = Object.freeze({
    "TaperFromBend" : "TaperFromBend", "TaperFromWeb" : "TaperFromWeb"});

export default SPLM;